import { appConfig, auth, callable } from "@@/db.js";

export const searchRegsV2 = (data) => callable("searchRegsV2")(data);
export const getRegSection = (data) => callable("getRegSection")(data);
export const getSectionVersions = (data) => callable("getSectionVersions")(data);
export const compareRegSections = (data) => callable("compareRegSections")(data);
export const searchAircraft = (data) => callable("searchAircraft")(data);

const withDatabaseURL = (data) => ({
    ...data,
    databaseURL: appConfig?.firebaseConfig?.databaseURL,
});

export const upsertAircraft = (data) => callable("upsertAircraft")(withDatabaseURL(data));
export const bulkUpsertAircraft = (data) => callable("bulkUpsertAircraft")(withDatabaseURL(data));
export const deleteAircraft = (data) => callable("deleteAircraft")(withDatabaseURL(data));

export const completeRegSectionReview = (data) => callable("completeRegSectionReview")({
    ...withDatabaseURL(data),
});

export async function getRegAssetBlob(pngPath) {
    const normalizedPath = String(pngPath || "").replaceAll("\\", "/").replace(/^\.\//, "");
    const segments = normalizedPath.split("/");
    if (
        !normalizedPath
        || normalizedPath.startsWith("/")
        || segments.some((segment) => !segment || segment === "." || segment === "..")
    ) {
        throw new Error("Invalid regulation asset path.");
    }

    const bucket = appConfig?.firebaseConfig?.storageBucket;
    const user = auth.currentUser;
    if (!bucket || !user) throw new Error("Sign in with access to view this source image.");

    const token = await user.getIdToken();
    const objectPath = `EASA_ASSETS/CS25/${segments.join("/")}`;
    const response = await fetch(
        `https://firebasestorage.googleapis.com/v0/b/${encodeURIComponent(bucket)}/o/${encodeURIComponent(objectPath)}?alt=media`,
        { headers: { Authorization: `Firebase ${token}` } }
    );
    if (!response.ok) {
        const error = new Error(response.status === 404
            ? "The source image has not been uploaded yet."
            : "The source image could not be loaded.");
        error.status = response.status;
        throw error;
    }
    return response.blob();
}
